import { customAlphabet } from 'nanoid';

type KeyGenerator = () => string;

let generate!: KeyGenerator;
resetKeyGenerator();

/**
 * Generate a key.
 */
export function generateKey(): string {
    return generate();
}

/**
 * Set a different unique ID generating `function`.
 */
export function setKeyGenerator(func: KeyGenerator) {
    generate = func;
}

/**
 * Globally initialize the Slate key generator that generates a UUID.
 */
export function resetKeyGenerator(): void {
    setKeyGenerator(() =>
        customAlphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789', 12)()
    );
}

/**
 * Setup a sequential Slate key generator. Used for tests.
 * Remember to restore to the production one at the end of your test
 * `afterAll()`.
 */
export function setSequentialKeyGenerator(prefix = ''): void {
    let counter = 0;
    setKeyGenerator(() => {
        counter += 1;
        return prefix + (counter - 1);
    });
}
